module.exports = __webpack_public_path__ + "img/venzologo.a8382317.png";